import { PANE_TRIGGER_SIZE } from '../constants/sizes';
import deriveItemsWidth from './derive-items-width';
import cpDirection from '../constants/cp-direction';
import getItemWidth from './get-item-width';

const deriveMaxItemsCountByWidth = (width, items) => {
  let availableWidth = width;
  let fittingItems = 0;

  items.forEach((item) => {
    const itemWidth = getItemWidth(item) || PANE_TRIGGER_SIZE;
    if (availableWidth - itemWidth >= 0) {
      availableWidth -= itemWidth;
      fittingItems += 1;
    }
  });

  return fittingItems;
};

const getPaneMaxItems = ({ direction, offsetX }, documentWidth, items) => {
  const paneWidth = deriveItemsWidth(items);

  switch (direction) {
    case cpDirection.RIGHT: {
      const availableWidth = documentWidth - offsetX;
      const itemsCount = deriveMaxItemsCountByWidth(availableWidth, items);

      return availableWidth >= paneWidth ? itemsCount : itemsCount - 1;
    }

    case cpDirection.LEFT: {
      const itemsCount = deriveMaxItemsCountByWidth(offsetX, items);

      return offsetX >= paneWidth ? itemsCount : itemsCount - 1;
    }

    default: {
      const availableWidth = documentWidth - PANE_TRIGGER_SIZE * 2;
      const itemsCount = deriveMaxItemsCountByWidth(availableWidth, items);
      return availableWidth >= paneWidth ? itemsCount : itemsCount - 1;
    }
  }
};

export default getPaneMaxItems;
